import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Customer } from './Customer';
import { Party } from './Party';

@supertypeClass({ toClient: true, toServer: true })
export class ResidentialAsset extends Persistable(Remoteable(Supertype)) {
  @property({
    rule: ['required'],
    comment: 'Asset Type',
  })
  type: string;

  @property({
    rule: ['required'],
    comment: 'Asset Description',
  })
  description: string;

  @property({
    rule: ['currency', 'numericPositive'],
    comment: 'Asset Value',
  })
  amount: number;

  @property({
    getType: () => Customer,
    comment: 'Link to Customer table',
  })
  customer: Customer;

  @property({
    getType: () => Party,
    comment: 'Link to Party table',
  })
  party: Party;

  constructor() {
    super();
  }

  static new(customer) {
    return new ResidentialAsset().init(customer);
  }

  init(customer) {
    this.customer = customer;
    return this;
  }
}
